import styled, { keyframes } from 'styled-components';
import { colors } from '../../variables/colors.js';

var loaderFx = keyframes(["0%{background-position:-300px 0;}100%{background-position:700px 0;}"]);
var LoadBlock = styled.div.withConfig({
  displayName: "style__LoadBlock",
  componentId: "sc-hcpdvb-0"
})(["height:100%;position:relative;width:100%;"]);
var Loader = styled.div.withConfig({
  displayName: "style__Loader",
  componentId: "sc-hcpdvb-1"
})(["animation-duration:2s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-name:", ";animation-timing-function:linear;background:", " no-repeat;background-image:linear-gradient(to left,", " 0%,", " 20%,", " 40%,", " 100%);background-size:200px 100%;height:100%;position:absolute;width:100%;"], loaderFx, colors.extraLightGray, colors.extraLightGray, colors.lightGray, colors.extraLightGray, colors.extraLightGray);

export { LoadBlock, Loader };
//# sourceMappingURL=style.js.map
